<template>
  <SiteSection
    sectionId="section-apply"
    sectionNo="6"
    label="應徵實習"
    title="APPLY"
  >
    <div class="subtitle">
      <p>
        看完我們的環境、福利以及歷屆實習生的心得，也歡迎追蹤以下粉絲團，進一步了解
        25sprout 的日常以及我們的產品唷！
      </p>
    </div>
    <div class="social">
      <a href="https://www.facebook.com/25sprout/">25sprout 官方粉絲專頁</a>
      <a href="https://www.instagram.com/25sprout/">25sprout Instagram</a>
      <a href="https://www.facebook.com/surveycake/">SurveyCake 官方粉絲專頁</a>
    </div>
    <div class="apply">
      <template v-for="(apply, index) in applies">
        <div class="apply-container">
          <div class="apply-text-container">
            <p class="apply-title">{{ apply.title }}</p>
            <div class="apply-department">
              <img :src="icon" />
              <p>{{ apply.department }}</p>
            </div>
          </div>
          <a :href="apply.link">Apply</a>
        </div>
      </template>
    </div>
  </SiteSection>
</template>

<script>
import SiteSection from "./source/Section.vue";
import { APPLY_DATA, AVAILABLE_APPLY } from "../models/Apply.js";
import applyIcon from "../static/images/sectionApply/department.svg";

export default {
  name: "SectionApply",
  components: {
    SiteSection,
  },
  data: function () {
    const filteredAppliesData = APPLY_DATA.filter((apply) =>
      AVAILABLE_APPLY.includes(apply.title)
    );

    return {
      applies: filteredAppliesData,
      icon: applyIcon,
    };
  },
};
</script>

<style scoped lang="scss">
@import "../static/styles/palette.scss";

.section {
  margin-top: 40px;
  padding-top: 68px;
  padding-bottom: 80px;

  & .subtitle {
    font-family: "Noto Sans TC";
    color: $darkGray;
    margin: 0 160px;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 2px;
  }

  & .social {
    margin: 29px 160px;
    display: flex;
    gap: 20px;

    & a {
      display: flex;
      padding: 5px 24px;
      justify-content: center;
      align-items: center;
      border-radius: 30px;
      border: 5px solid $blue;
      background-color: white;
      color: $blue;
      font-family: "Noto Sans TC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 40px;
      letter-spacing: 2px;
      text-decoration: none;
    }

    & a:hover {
      background-color: $blue;
      color: white;
    }
  }

  & .apply {
    margin: 48px 160px;

    & .apply-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 40px 24px;
      gap: 8px;
    }

    & .apply-text-container {
      display: flex;
      flex-direction: column;
      gap: 8px;

      & .apply-title {
        font-family: Roboto;
        font-size: 32px;
        font-style: normal;
        font-weight: 900;
        letter-spacing: 2px;
        margin: 0;
      }

      & .apply-department {
        display: flex;
        flex-direction: row;
        gap: 12px;
        color: $blue;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 2px;

        & p {
          display: flex;
          align-items: center;
          margin: 0;
        }
      }
    }

    & a {
      height: 56px;
      display: flex;
      padding: 8px 64px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 50px;
      border: none;
      background: $blue;
      color: white;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 900;
      letter-spacing: 2px;
      text-decoration: none;
    }

    & a:hover {
      opacity: 0.8;
    }
  }
}

@media all and (max-width: 960px) {
  .section {
    & .apply {
      margin: 48px 160px;

      & .apply-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 40px 24px;
      }
    }
  }
}

// Tablet css
@media all and (max-width: 768px) {
  .section {
    & .subtitle {
      color: $darkGray;
      margin: 0 40px;
    }

    & .social {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 25px 40px;
    }

    & .apply {
      margin: 40px 40px;

      & .apply-container {
        padding: 32px 0;
      }
    }
  }
}

// Phone XL css
@media all and (max-width: 480px) {
  .section {
    & .subtitle {
      color: $darkGray;
      margin: 0 40px;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
      letter-spacing: 2px;
    }

    & .social {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 25px 20px;

      & a {
        display: flex;
        padding: 5px 24px;
        justify-content: center;
        align-items: center;
        border-radius: 30px;
        border: 5px solid $blue;
        background-color: white;
        color: $blue;
        font-family: "Noto Sans TC";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 40px;
        letter-spacing: 2px;
        text-decoration: none;
      }

      & a:hover {
        background-color: $blue;
        color: white;
      }
    }

    & .apply {
      margin: 40px 40px;

      & .apply-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 32px 0;
        gap: 24px;

        & .apply-text-container {
          width: 100%;
          & .apply-title {
            font-size: 24px;
          }

          & .apply-department {
            font-size: 16px;
          }
        }

        & a {
          width: 180px;
        }
      }
    }
  }
}

// Phone css
@media all and (max-width: 320px) {
  .section {
    & .subtitle {
      color: $darkGray;
      margin: 0 40px;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
      letter-spacing: 2px;
    }

    & .social {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 25px 20px;

      & a {
        display: flex;
        padding: 5px 24px;
        justify-content: center;
        align-items: center;
        border-radius: 30px;
        border: 5px solid $blue;
        background-color: white;
        color: $blue;
        font-family: "Noto Sans TC";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 40px;
        letter-spacing: 2px;
        text-decoration: none;
      }

      & a:hover {
        background-color: $blue;
        color: white;
      }
    }

    & .apply {
      margin: 40px 40px;

      & .apply-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 32px 0;
        gap: 24px;

        & .apply-text-container {
          width: 100%;
          & .apply-title {
            font-size: 24px;
          }

          & .apply-department {
            font-size: 16px;
          }
        }

        & a {
          width: 140px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// SectionApply.vue?0146bc4b